import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translate resources for different languages
const resources = {
 es: {
  translation: {
   About: 'Acerca de',
   Articles: 'Artículos',
   Dashboard: 'Panel',
   Home: 'Inicio',
   Welcome: 'Bienvenidos',
   Profile: 'Perfil',
   Settings: 'Configuración',
   Contact: 'Contacto',
   Messages: 'Mensajes',
   Search: 'Buscar',
   GoBack: 'Volver',
   answer: {
    no: 'No',
    yes: 'Si',
   },
   pagination: {
    previous: 'Anterior',
    next: 'Siguiente',
   },
   admin: {
    backup_management: 'Gestión de Backups',
    generate_backup: 'Generar Respaldo',
    upload_backup: 'Subir Respaldo',
    uploading_backup: 'Subiendo Respaldo',
    generating_backup: 'Generando Respaldo',
    last_backup_generated: 'Último respaldo generado',
    backup_success: 'Respaldo generado exitosamente',
    backup_error: 'Error al generar el respaldo',
    backup_upload_success: 'Respaldo subido exitosamente',
    backup_upload_error: 'Error al subir el respaldo',
    last_backup: 'Último Respaldo',
    file_name: 'Nombre del archivo',
    generated_at: 'Generado el',
    uploaded: 'Subido',
    google_drive_file_id: 'ID del archivo en Google Drive',
    backup_folder: 'Carpeta de respaldo',
    there_is_no_backup_yet: 'Aún no hay respaldo registrado',
    download: 'Descargar',
    delete_backup: 'Eliminar Respaldo',
   },
   home: {
    back_to_home: 'Volver al inicio',
    discover_inspiration: '¡Descubre inspiración en cada palabra! ¡Explora mis artículos, despierta nuevas ideas!',
    read_more: 'Leer más',
    start: '¡Comienza tu viaje hacia una vida más saludable y en forma! Cada paso cuenta, cada esfuerzo suma. Con cada sesión de ejercicio, no solo fortaleces tu cuerpo, sino también tu mente. Descubre el poder transformador de cuidar de ti mismo, alcanzando metas que te harán sentir más enérgico, centrado y feliz. ¡Tú mereces invertir en tu bienestar! ¡Vamos, tú puedes hacerlo!',
    begin: 'Comienza',
    transform_your_life: 'Transforma tu vida con ejercicios, rutinas y motivación',
    activate_your_life: '¡Activa tu vida, transforma tu salud! ¡Ejercítate para un mejor tú!',
    discover_articles: 'Descubre artículos inspiradores',
    discover_videos: 'Descubre videos inspiradores',
    discover_routines: 'Descubre rutinas de ejercicios',
    learn_more: 'Aprende más',
   },
   articles: {
    edit: 'Editar',
    published_on: 'Publicado el',
    by: 'por',
    continue_reading: 'continuar leyendo',
    comments: 'comentarios',
    no_comments_yet: 'No hay comentarios aun',
    not_published: 'Este artículo no está publicado',
    comment: {
     username: 'Nombre del usuario',
     content: 'Contenido',
     save_comment: 'Enviar comentario',
     leave_a_comment: 'Dejar un comentario',
     errors: {
      author_name_is_required: 'Nombre es requerido',
      author_name_length: 'El nombre debe tener al menos 3 caracteres',
     },
    },
    form: {
     title: 'Título',
     subheading: 'Subtitulo',
     video: 'Video',
     content: 'Contenido',
     save_article: 'Grabar Artículo',
     upload_image_for: 'Subir imagen para',
     load_image: 'Cargar Imágen',
    },
   },
   dashboard: {
    dashboard: 'Panel',
    new: 'Nuevo',
    title: 'Titulo',
    published: 'Publicado',
    published_at: 'Publicado el',
    image: 'Imagen',
    actions: 'Acciones',
    change_image: 'Cambiar Imagen',
    edit: 'Editar',
    delete: 'Eliminar',
    hide: 'Esconder',
    publish: 'Publicar',
    upload_image: 'Cargar Imagen',
    search_for_items: 'Buscar por nombre',
    list: 'Artículos',
    preview: 'Vista Previa',
   },
   login: {
    email: 'Email',
    password: 'Contraseña',
    login: 'Iniciar Sesión',
    remember_me: 'Recordarme',
    forgot_password: 'Olvidé mi contraseña',
    login_with_google: 'Iniciar sesión con Google',
    sign_in: 'Iniciar sesión',
    recover_password: 'Recuperar contraseña',
   },
   profile: {
    about_me: 'Sobre mí',
    profile: 'Perfil',
    edit_profile: 'Editar Perfil',
    show_profile: 'Ver Perfil',
    username: 'Nombre de Usuario',
    email: 'Correo Electrónico',
    bio: 'Biografía',
    save_profile: 'Guardar Perfil',
    general_information: 'Información General',
   },
   password: {
    password: 'Contraseña',
    show_password_form: 'Mostrar formulario de contraseña',
    hide_password_form: 'Ocultar formulario de contraseña',
    change_password: 'Cambiar contraseña',
    password_confirmation: 'Debes confirmar la contraseña',
    password_does_not_match: 'La contraseña no coincide',
    minimum_length: 'La contraseña debe tener al menos 8 caracteres',
    maximum_length: 'La contraseña no puede superar los 20 caracteres',
    update_password: 'Actualizar contraseña',
    recover_password: 'Recuperar contraseña',
    recover_password_process: 'Envíenos su correo electronico y recibirá el link para recuperar su contraseña',
    recovery_confirmation_success: 'Recuperación de contraseña exitosa',
    recovery_confirmation_error: 'Error en la recuperación de contraseña',
    recovery_confirmation_error_message: 'El token de recuperación no es válido o ha expirado',
    recovery_confirmation_success_message: 'Ahora puedes iniciar sesión con tu nueva contraseña.',
    error: 'Ocurrió un error inesperado. Por favor, intentalo más tarde.',
   },
   contact: {
    username: 'Nombre',
    email: 'Email',
    content: 'Contenido',
    send_message: 'Enviar Mensaje',
    created_at: 'Creado el',
    write_your_reason_of_contact_here: 'Escribe aquí tu razón del contacto',
    errors: {
     author_name_is_required: 'Nombre es requerido',
     author_name_length: 'El nombre debe tener al menos 3 caracteres',
     email_is_required: 'Email es requerido',
     email_is_not_valid: 'Email no es valido',
     content_is_required: 'El contenido es requerido',
     min_length: 'Contenido mínimo no alcanzado',
    },
   },
  },
 },
 en: {
  translation: {
   About: 'About',
   Articles: 'Articles',
   Dashboard: 'Dashboard',
   Home: 'Home',
   Welcome: 'Welcome',
   Profile: 'Profile',
   Settings: 'Settings',
   Contact: 'Contact',
   Messages: 'Messages',
   Search: 'Search',
   GoBack: 'Go Back',
   answer: {
    no: 'No',
    yes: 'Yes',
   },
    pagination: {
    previous: 'Previous',
    next: 'Next',
    },
    admin: {
      backup_management: 'Backup Management',
      generate_backup: 'Generate Backup',
      uploading_backup: 'Uploading Backup',
      generating_backup: 'Generating Backup',
      last_backup_generated: 'Last backup generated',
      upload_backup: 'Upload Backup',
      backup_success: 'Backup generated successfully',
      backup_error: 'Error generating backup',
      backup_upload_success: 'Backup uploaded successfully',
      backup_upload_error: 'Error uploading backup',
      last_backup: 'Last Backup',
      file_name: 'File Name',
      generated_at: 'Generated At',
      uploaded: 'Uploaded',
      google_drive_file_id: 'Google Drive File ID',
      backup_folder: 'Backup Folder',
      there_is_no_backup_yet: 'There is no backup registered yet',
      download: 'Download',
      delete_backup: 'Delete Backup',
    },
    home: {
      back_to_home: 'Back to Home',
      discover_inspiration: 'Discover inspiration in every word! Explore my articles, awaken new ideas!',
      read_more: 'Read more',
      start: 'Start your journey towards a healthier and fitter life! Every step counts, every effort adds up. With each workout session, you not only strengthen your body but also your mind. Discover the transformative power of self-care, reaching goals that will make you feel more energetic, focused, and happy. You deserve to invest in your well-being! Let’s go, you can do it!',
      begin: 'Begin',
      transform_your_life: 'Transform your life with exercises, routines, and motivation',
      activate_your_life: 'Activate your life, transform your health! Exercise for a better you!',
      discover_articles: 'Discover inspiring articles',
      discover_videos: 'Discover inspiring videos',
      discover_routines: 'Discover exercise routines',
      learn_more: 'Learn more',
    },
   articles: {
    edit: 'Edit',
    published_on: 'Published on',
    by: 'by',
    continue_reading: 'continue reading',
    comments: 'comments',
    no_comments_yet: 'No comments yet',
    not_published: 'This article is not published',
    comment: {
     username: 'Username',
     content: 'Content',
     save_comment: 'Save Comment',
     leave_a_comment: 'Leave a comment',
     errors: {
      author_name_is_required: 'Author name is required',
      author_name_length: 'Author name length must be at least 3 characters',
     },
    },
    form: {
     title: 'Title',
     subheading: 'Subheading',
     video: 'Video',
     content: 'Content',
     save_article: 'Save Article',
     upload_image_for: 'Upload image for',
     load_image: 'Load Image',
    },
   },
   dashboard: {
    dashboard: 'Dashboard',
    new: 'New',
    title: 'Title',
    published: 'Published',
    published_at: 'Published At',
    image: 'Image',
    actions: 'Actions',
    change_image: 'Change Image',
    edit: 'Edit',
    delete: 'Delete',
    hide: 'Hide',
    publish: 'Publish',
    upload_image: 'Upload Image',
    search_for_items: 'Search for items',
    list: 'Articles',
    preview: 'Preview',
   },
   login: {
    email: 'Email',
    password: 'Password',
    login: 'Login',
    remember_me: 'Remember me',
    forgot_password: 'Forgot password',
    login_with_google: 'Login with Google',
    sign_in: 'Sign in',
    recover_password: 'Recover password',
   },
   profile: {
    about_me: 'About Me',
    profile: 'Profile',
    edit_profile: 'Edit Profile',
    show_profile: 'Show Profile',
    username: 'Username',
    email: 'Email',
    bio: 'Bio',
    save_profile: 'Save Profile',
    general_information: 'General Information',
   },
   password: {
    password: 'Password',
    show_password_form: 'Show password form',
    hide_password_form: 'Hide password form',
    change_password: 'Change password',
    password_confirmation: 'You must confirm the password',
    password_does_not_match: 'Password does not match',
    minimum_length: 'Password must be at least 8 characters long',
    maximum_length: 'Password cannot exceed 20 characters',
    update_password: 'Update password',
    recover_password: 'Recover password',
    recover_password_process: 'Send us your email and you will receive the link to recover your password',
    recovery_confirmation_success: 'Password recovery successful',
    recovery_confirmation_error: 'Password recovery error',
    recovery_confirmation_error_message: 'The recovery token is invalid or has expired',
    recovery_confirmation_success_message: 'The password has been successfully updated',
    error: 'An unexpected error occurred. Please try again later.',
   },
   contact: {
    username: 'Username',
    email: 'Email',
    content: 'Content',
    send_message: 'Send Message',
    write_your_reason_of_contact_here: 'Write your reason of contact here',
    created_at: 'Created at',
    errors: {
     author_name_is_required: 'Name is required',
     author_name_length: 'Name at least 3 characters long',
     email_is_required: 'Email is required',
     email_is_not_valid: 'Email is not valid',
     content_is_required: 'Content is required',
     min_length: 'Minimum lengt required at lest 100 characters',
    },
   },
  },
 },
 pt: {
  translation: {
   About: 'Sobre',
   Articles: 'Artigos',
   Dashboard: 'Painel',
   Home: 'Início',
   Welcome: 'Bem-vindos',
   Profile: 'Perfil',
   Settings: 'Configuração',
   Contact: 'Contato',
   Messages: 'Mensagens',
   Search: 'Buscar',
   GoBack: 'Voltar',
   answer: {
    no: 'Não',
    yes: 'Sim',
   },
    pagination: {
    previous: 'Anterior',
    next: 'Próximo',
    },
    admin: {
      backup_management: 'Gerenciamento de Backup',
      generate_backup: 'Gerar Backup',
      uploading_backup: 'Enviando Backup',
      generating_backup: 'Gerando Backup',
      last_backup_generated: 'Último backup gerado',
      upload_backup: 'Enviar Backup',
      backup_success: 'Backup gerado com sucesso',
      backup_error: 'Erro ao gerar o backup',
      backup_upload_success: 'Backup enviado com sucesso',
      backup_upload_error: 'Erro ao enviar o backup',
      last_backup: 'Último Backup',
      file_name: 'Nome do arquivo',
      generated_at: 'Gerado em',
      uploaded: 'Enviado',
      google_drive_file_id: 'ID do arquivo no Google Drive',
      backup_folder: 'Pasta de backup',
      there_is_no_backup_yet: 'Ainda não há backup registrado',
      download: 'Baixar',
      delete_backup: 'Excluir Backup',
    },
    home: {
      back_to_home: 'Voltar para o Início',
      discover_inspiration: 'Descubra inspiração em cada palavra! Explore meus artigos, desperte novas ideias!',
      read_more: 'Leia mais',
      start: 'Comece sua jornada rumo a uma vida mais saudável e em forma! Cada passo conta, cada esforço soma. A cada sessão de treino, você não apenas fortalece seu corpo, mas também sua mente. Descubra o poder transformador do autocuidado, alcançando metas que farão você se sentir mais enérgico, focado e feliz. Você merece investir no seu bem-estar! Vamos lá, você consegue!',
      begin: 'Começar',
      transform_your_life: 'Transforme sua vida com exercícios, rotinas e motivação',
      activate_your_life: 'Ative sua vida, transforme sua saúde! Exercite-se para um você melhor!',
      discover_articles: 'Descubra artigos inspiradores',
      discover_videos: 'Descubra vídeos inspiradores',
      discover_routines: 'Descubra rotinas de exercícios',
      learn_more: 'Saiba mais',
    },
   articles: {
    edit: 'Editar',
    published_on: 'Publicado em',
    by: 'por',
    continue_reading: 'continuar lendo',
    comments: 'comentários',
    no_comments_yet: 'Ainda não há comentários',
    not_published: 'Este artigo não está publicado',
    comment: {
     username: 'Nome do usuário',
     content: 'Conteúdo',
     save_comment: 'Enviar comentário',
     leave_a_comment: 'Deixar um comentário',
     errors: {
      author_name_is_required: 'O nome do autor é obrigatório',
      author_name_length:
       'O comprimento do nome do autor deve ser de pelo menos 3 caracteres',
     },
    },
    form: {
     title: 'Título',
     subheading: 'Subtítulo',
     video: 'Vídeo',
     content: 'Conteúdo',
     save_article: 'Salvar Artigo',
     upload_image_for: 'Carregar imagem para',
     load_image: 'Carregar Imagem',
    },
   },
   dashboard: {
    dashboard: 'Painel',
    new: 'Novo',
    title: 'Título',
    published: 'Publicado',
    published_at: 'Publicado em',
    image: 'Imagem',
    actions: 'Ações',
    change_image: 'Mudar Imagem',
    edit: 'Editar',
    delete: 'Excluir',
    hide: 'Esconder',
    publish: 'Publicar',
    upload_image: 'Carregar Imagem',
    search_for_items: 'Procurar por nome',
    list: 'Artigos',
    preview: 'Pré-visualização',
   },
    login: {
      email: 'Email',
      password: 'Senha',
      login: 'Entrar',
      remember_me: 'Lembrar de mim',
      forgot_password: 'Esqueci minha senha',
      login_with_google: 'Entrar com o Google',
      sign_in: 'Entrar',
      recover_password: 'Recuperar senha',
      },
   profile: {
    about_me: 'Sobre mim',
    profile: 'Perfil',
    edit_profile: 'Editar Perfil',
    show_profile: 'Ver Perfil',
    username: 'Nome de Usuário',
    email: 'Email',
    bio: 'Biografia',
    save_profile: 'Salvar Perfil',
    general_information: 'Informações Gerais',
   },
   password: {
    password: 'Senha',
    show_password_form: 'Mostrar formulário de senha',
    hide_password_form: 'Ocultar formulário de senha',
    change_password: 'Alterar a senha',
    password_confirmation: 'Você deve confirmar a senha',
    password_does_not_match: 'A senha não corresponde',
    minimum_length: 'A senha deve ter pelo menos 8 caracteres',
    maximum_length: 'A senha não pode exceder 20 caracteres',
    update_password: 'Atualizar senha',
    recover_password: 'Recuperar senha',
    recover_password_process: 'Envie-nos seu e-mail e você receberá o link para recuperar sua senha',
    recovery_confirmation_success: 'Recuperação de senha bem-sucedida',
    recovery_confirmation_error: 'Erro na recuperação de senha',
    recovery_confirmation_error_message: 'O token de recuperação é inválido ou expirou',
    recovery_confirmation_success_message: 'A senha foi atualizada com sucesso',
    error: 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.',
   },
   contact: {
    username: 'Nome de Usuário',
    email: 'Email',
    content: 'Conteudo',
    send_message: 'Enviar Messagem',
    write_your_reason_of_contact_here: 'Escreva aqui o seu motivo de contato',
    created_at: 'Criado em',
    errors: {
     author_name_is_required: 'Nome é obrigatório',
     author_name_length: 'Nomeie pelo menos 3 caracteres',
     email_is_required: 'E-mail é obrigatório',
     email_is_not_valid: 'E-mail não é válido',
     content_is_required: 'Conteúdo é obrigatório',
     min_length: 'Comprimento mínimo exigido de pelo menos 100 caracteres',
    },
   },
  },
 },
 fr: {
  translation: {
   About: 'À propos',
   Articles: 'Articles',
   Dashboard: 'Tableau de bord',
   Home: 'Accueil',
   Welcome: 'Bienvenue',
   Profile: 'Profil',
   Settings: 'Paramètres',
   Contact: 'Contact',
   Messages: 'Messages',
   Search: 'Recherche',
   GoBack: 'Retour',
   answer: {
    no: 'Non',
    yes: 'Oui',
   },
    home: {
      back_to_home: 'Retour à l\'accueil',
      discover_inspiration: 'Découvrez l\'inspiration dans chaque mot ! Explorez mes articles, réveillez de nouvelles idées !',
      read_more: 'Lire la suite',
      start: 'Commencez votre voyage vers une vie plus saine et en forme ! Chaque pas compte, chaque effort s\'additionne. À chaque séance d\'exercice, vous renforcez non seulement votre corps, mais aussi votre esprit. Découvrez le pouvoir transformateur de prendre soin de vous, atteignant des objectifs qui vous feront vous sentir plus énergique, concentré et heureux. Vous méritez d\'investir dans votre bien-être ! Allons-y, vous pouvez le faire !',
      begin: 'Commencer',
      transform_your_life: 'Transformez votre vie avec des exercices, des routines et de la motivation',
      activate_your_life: 'Activez votre vie, transformez votre santé ! Faites de l\'exercice pour un meilleur vous !',
      discover_articles: 'Découvrez des articles inspirants',
      discover_videos: 'Découvrez des vidéos inspirantes',
      discover_routines: 'Découvrez des routines d\'exercices',
      learn_more: 'En savoir plus',
    },
    pagination: {
    previous: 'Précédent',
    next: 'Suivant',
    },
    admin: {
      backup_management: 'Gestion des sauvegardes',
      generate_backup: 'Générer une sauvegarde',
      uploading_backup: 'Téléchargement de la sauvegarde',
      generating_backup: 'Génération de la sauvegarde',
      last_backup_generated: 'Dernière sauvegarde générée',
      upload_backup: 'Télécharger une sauvegarde',
      backup_success: 'Sauvegarde générée avec succès',
      backup_error: 'Erreur lors de la génération de la sauvegarde',
      backup_upload_success: 'Sauvegarde téléchargée avec succès',
      backup_upload_error: 'Erreur lors du téléchargement de la sauvegarde',
      last_backup: 'Dernière sauvegarde',
      file_name: 'Nom du fichier',
      generated_at: 'Généré le',
      uploaded: 'Téléchargé',
      google_drive_file_id: 'ID du fichier Google Drive',
      backup_folder: 'Dossier de sauvegarde',
      there_is_no_backup_yet: 'Aucune sauvegarde enregistrée pour le moment',
      download: 'Télécharger',
      delete_backup: 'Supprimer la sauvegarde',
    },
   articles: {
    edit: 'Éditer',
    published_on: 'Publié le',
    by: 'par',
    continue_reading: 'continuer à lire',
    comments: 'commentaires',
    no_comments_yet: 'Pas encore de commentaires',
    not_published: 'Cet article n\'est pas publié',
    comment: {
     username: "Nom d'utilisateur",
     content: 'Contenu',
     save_comment: 'Envoyer commentaire',
     leave_a_comment: 'Laisser un commentaire',
     errors: {
      author_name_is_required: "Le nom de l'auteur est requis",
      author_name_length:
       "La longueur du nom de l'auteur doit être d'au moins 3 caractères",
     },
    },
    form: {
     title: 'Titre',
     subheading: 'Sous-titre',
     video: 'Vidéo',
     content: 'Contenu',
     save_article: "Enregistrer l'article",
     upload_image_for: 'Télécharger une image pour',
     load_image: 'Télécharger une image',
    },
   },
   dashboard: {
    dashboard: 'Tableau de bord',
    new: 'Nouveau',
    title: 'Titre',
    published: 'Publié',
    published_at: 'Publié le',
    image: 'Image',
    actions: 'Actions',
    change_image: "Changer d'image",
    edit: 'Éditer',
    delete: 'Supprimer',
    hide: 'Cacher',
    publish: 'Publier',
    upload_image: 'Télécharger une image',
    search_for_items: 'Rechercher par nom',
    list: 'Articles',
    preview: 'Aperçu',
   },
   login: {
    email: 'Email',
    password: 'Mot de passe',
    login: 'Connexion',
    remember_me: 'Se souvenir de moi',
    forgot_password: 'Mot de passe oublié',
    login_with_google: 'Se connecter avec Google',
    sign_in: 'Se connecter',
    recover_password: 'Récupérer le mot de passe',
   },
   profile: {
    about_me: 'Sur moi',
    profile: 'Profil',
    edit_profile: 'Modifier le profil',
    show_profile: 'Voir le profil',
    username: "Nom d'utilisateur",
    email: 'Email',
    bio: 'Biographie',
    save_profile: 'Enregistrer le profil',
    general_information: 'Informations générales',
   },
   password: {
    password: 'Mot de passe',
    show_password_form: 'Afficher le formulaire de mot de passe',
    hide_password_form: 'Masquer le formulaire de mot de passe',
    change_password: 'Changer le mot de passe',
    password_confirmation: 'Vous devez confirmer le mot de passe',
    password_does_not_match: 'Le mot de passe ne correspond pas',
    minimum_length: 'Le mot de passe doit comporter au moins 8 caractères',
    maximum_length: 'Le mot de passe ne peut pas dépasser 20 caractères',
    update_password: 'Mettre à jour le mot de passe',
    recover_password: 'Récupérer le mot de passe',
    recover_password_process: 'Envoyez-nous votre e-mail et vous recevrez le lien pour récupérer votre mot de passe',
    recovery_confirmation_success: 'Récupération de mot de passe réussie',
    recovery_confirmation_error: 'Erreur de récupération de mot de passe',
    recovery_confirmation_error_message: 'Le jeton de récupération est invalide ou a expiré',
    recovery_confirmation_success_message: 'Le mot de passe a été mis à jour avec succès',
    error: 'Une erreur inattendue est survenue. Veuillez réessayer plus tard.',
   },
   contact: {
    username: "Nom d'utilisateur",
    email: 'Email',
    content: 'Contenu',
    send_message: 'Envoyer un message',
    write_your_reason_of_contact_here: 'Écrivez ici le motif de votre contact',
    created_at: 'Créé à',
    errors: {
     author_name_is_required: 'Le nom est requis',
     author_name_length: 'Nommez au moins 3 caractères',
     email_is_required: 'Un e-mail est requis',
     email_is_not_valid: "L'email n'est pas valide",
     content_is_required: 'Le contenu est requis',
     min_length: 'Longueur minimale requise au moins 100 caractères',
    },
   },
  },
 },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Idioma por defecto
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
